module.exports = __webpack_public_path__ + "static/media/wood_closedoor_left.5581a2a8.png";